export default "__VITE_ASSET__4e5b455e__"